import { JsonObject } from '../../helpers';
import { PrivateModelModel } from './private-model.model';

export type AzureOpenAIPrivateModelConfig = {
  deploymentId: string;
};

export class AzureOpenAIPrivateModelModel extends PrivateModelModel {
  config: AzureOpenAIPrivateModelConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof PrivateModelModel, unknown>;

    this.provider = 'azure';

    this.config = (data.config as AzureOpenAIPrivateModelConfig) || {
      deploymentId: '',
    };
  }
}
